export default "__VITE_ASSET__hSwt5VyU__"